import Resource from '@/api/resource';
import request from '@/utils/request';

/**
 * Moderacja inwestycji deweloperskich (backend: Api/Admin/InvestmentController).
 * Admin operuje na ID (nie slugu). Odpowiedź list(): { items, total, per_page,
 * current_page, last_page } - bez wrappera data. get()/update() zwracają
 * pojedynczą inwestycję (kształt InvestmentResource), units() tablicę lokali
 * (ceny w GROSZACH) - również bez wrappera.
 */
class InvestmentResource extends Resource {
  constructor() {
    super('admin/investments');
  }

  /**
   * Usuwa inwestycję. withUnits=false (domyślnie, bezpieczniejsze) odpina lokale
   * - zostają jako zwykłe ogłoszenia; withUnits=true kasuje je razem z inwestycją.
   */
  destroy(id, withUnits = false) {
    return request({
      url: '/' + this.uri + '/' + id,
      method: 'delete',
      params: { with_units: withUnits ? 1 : 0 },
    });
  }

  // Wszystkie lokale inwestycji (także czekające na moderację i sprzedane).
  units(id) {
    return request({
      url: '/' + this.uri + '/' + id + '/units',
      method: 'get',
    });
  }

  // Usunięcie pojedynczego lokalu (kasuje jego ogłoszenie).
  destroyUnit(id, offerId) {
    return request({
      url: '/' + this.uri + '/' + id + '/units/' + offerId,
      method: 'delete',
    });
  }

  changeStatus(id, status) {
    return request({
      url: '/' + this.uri + '/' + id + '/status',
      method: 'patch',
      data: { status: status },
    });
  }

  // Hurtowa aktywacja lokali czekających na moderację (IN_ACTIVE);
  // nie rusza sprzedanych/wyłączonych. Zwraca { activated, active_units_count }.
  activateUnits(id) {
    return request({
      url: '/' + this.uri + '/' + id + '/activate-units',
      method: 'post',
    });
  }
}

export { InvestmentResource as default };
